import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, GraduationCapIcon, PhoneCallIcon, HandshakeIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidJessePage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2335">
      <SEO title="Jesse Put, Junior Sales Executive | Noord Digital" description="Maak kennis met Jesse Put, Junior Sales Executive bij Noord Digital. Loopt stage om het sales-vak te leren van Rocco en Jelle." canonical="https://noorddigital.nl/over-ons/jesse" data-id="element-2336" />
      <Header data-id="element-2337" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2338">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2339">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2340">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2341" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2342">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2343">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg bg-gradient-to-br from-[#EEF5FA] to-[#DCE9F5]" data-id="element-2344">
                <img src="https://cdn.magicpatterns.com/uploads/8MJF64emYA1SRDFsWSY2N8/Norden_Jesse_put.png" alt="Jesse Put" className="w-full h-full object-cover" data-id="element-2345" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2346">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2347">
                Jesse Put
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2348">
                Junior Sales Executive
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2349">
                <p className="mb-4" data-id="element-2350">
                  Als Junior Sales Executive loop ik stage bij Noord Digital om
                  het sales-vak in de praktijk te leren. Ik werk nauw samen met
                  Rocco en Jelle, kijk mee in gesprekken en pak gaandeweg meer
                  zelfstandig op.
                </p>
                <p className="mb-4" data-id="element-2351">
                  Mijn rol is vooral leren door te doen: voorbereiden,
                  meeluisteren, opvolgen en de juiste vragen leren stellen. Geen
                  scripts, wel oprecht nieuwsgierig naar wat er bij jouw bedrijf
                  speelt.
                </p>
                <p data-id="element-2352">
                  Een frisse blik kan helpen. Ik stel soms net die ene vraag die
                  een ander vergeet, en dat levert vaak het scherpste inzicht op
                  voor een passend voorstel.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2353">
                Expertise in ontwikkeling
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2354">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2355">
                  <GraduationCapIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2356" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2357">Stage in sales</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2358">
                  <PhoneCallIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2359" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2360">Eerste contact</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2361">
                  <HandshakeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2362" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2363">Opvolging</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2364">
                Neem contact op met Jesse
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2365" />
    </div>;
};